exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".whs-detail-hotel-fulldescription-paragraphs h4{font-size:18px;font-weight:500;margin:0}.whs-detail-hotel-fulldescription-paragraphs h4:before{content:\"\\F594\";width:24px;font:900 normal normal 18px/1 Font Awesome\\ 5 Pro;text-rendering:auto;-webkit-font-smoothing:antialiased;color:var(--color-alt-5);margin-right:12px}", ""]);

// exports
